"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Notification Service
 * User notification api documentation
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplacementVariableByCategoryToJSON = exports.ReplacementVariableByCategoryFromJSONTyped = exports.ReplacementVariableByCategoryFromJSON = exports.ReplacementVariableByCategoryIdEnum = void 0;
/**
* @export
* @enum {string}
*/
var ReplacementVariableByCategoryIdEnum;
(function (ReplacementVariableByCategoryIdEnum) {
    ReplacementVariableByCategoryIdEnum["User"] = "user";
    ReplacementVariableByCategoryIdEnum["Mission"] = "mission";
    ReplacementVariableByCategoryIdEnum["PlainReachoutSingle"] = "plainReachoutSingle";
    ReplacementVariableByCategoryIdEnum["PlainReachoutMultiple"] = "plainReachoutMultiple";
})(ReplacementVariableByCategoryIdEnum = exports.ReplacementVariableByCategoryIdEnum || (exports.ReplacementVariableByCategoryIdEnum = {}));
function ReplacementVariableByCategoryFromJSON(json) {
    return ReplacementVariableByCategoryFromJSONTyped(json, false);
}
exports.ReplacementVariableByCategoryFromJSON = ReplacementVariableByCategoryFromJSON;
function ReplacementVariableByCategoryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'label': json['label'],
        'variables': json['variables'],
    };
}
exports.ReplacementVariableByCategoryFromJSONTyped = ReplacementVariableByCategoryFromJSONTyped;
function ReplacementVariableByCategoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'label': value.label,
        'variables': value.variables,
    };
}
exports.ReplacementVariableByCategoryToJSON = ReplacementVariableByCategoryToJSON;
